import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import routes from "./router";
import "./css/styles.css";
import "./css/themes.css";
import "./css/print.css";

const hist = createBrowserHistory();
ReactDOM.render(
    <Router history={hist}>
        <Switch>
            {routes.map((route, key) => {
                return <Route path={route.path} key={key} component={route.component} />;
            })}
        </Switch>
    </Router>,
    document.getElementById("root")
);

